<template>
    <div class="video grid grid__base">
        <div class="video-container grid--container">
            <div class="video--row grid--row">
                <div class="video--col grid--col">
                    <div class="video--iframe-wrapper">
                        <iframe class="video--iframe"
                                gesture="media"
                                allow="encrypted-media"
                                allowfullscreen
                                :src="url"/>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        props: {
            url: {
                type: String,
                required: true,
            },
        },
    };
</script>
